export default () => ({
  month: 0,
  year: 0,
  events: {},
  states: {},
  calendars: [],
  calendarStatus: '',
  mobile: true
})
